import { cn } from "@/lib/utils";

export const LOGO_SRC = "/brand/gostops-logo.png";
export const ICON_SRC = "/brand/gostops-icon.webp";

export const BrandIcon = ({ className }) => (
  <img
    src={ICON_SRC}
    alt="goSTOPS"
    className={cn("h-8 w-8 rounded-lg object-cover shadow-sm", className)}
    draggable={false}
  />
);

export const BrandLogo = ({ className }) => (
  <img src={LOGO_SRC} alt="goSTOPS" className={cn("h-8 w-auto object-contain", className)} draggable={false} />
);

export const GoStopsMark = ({ className, compact = false }) => (
  <div className={cn("flex items-center gap-2.5", className)} data-testid="gostops-mark">
    <BrandIcon />
    {!compact && (
      <>
        <BrandLogo className="hidden h-6 sm:block" />
        <span className="hidden h-5 w-px bg-border sm:block" />
        <span className="hidden text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground sm:block">
          HR Command Center
        </span>
      </>
    )}
  </div>
);

const FINGERS = [
  { color: "bg-brand-teal", tilt: "-62deg", x: "-4%", y: "46%", h: "34%" },
  { color: "bg-brand-cyan", tilt: "-38deg", x: "12%", y: "18%", h: "44%" },
  { color: "bg-brand-purple", tilt: "-14deg", x: "34%", y: "0%", h: "50%" },
  { color: "bg-brand-pink", tilt: "8deg", x: "58%", y: "-2%", h: "48%" },
  { color: "bg-brand-orange", tilt: "34deg", x: "82%", y: "22%", h: "26%" },
];

export const HandMotif = ({ className }) => (
  <div className={cn("pointer-events-none relative aspect-square", className)} aria-hidden="true">
    <div className="absolute left-[14%] top-[36%] h-[64%] w-[64%] rounded-full bg-white/90 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.25)]" />
    <div className="absolute left-[30%] top-[52%] h-[36%] w-[36%] rounded-full border-[14px] border-primary border-r-transparent" />
    <div className="absolute left-[40%] top-[62%] h-[16%] w-[16%] rounded-full border-[10px] border-primary border-b-transparent" />
    {FINGERS.map((f, i) => (
      <span
        key={f.color}
        className={cn("finger absolute w-[13%] rounded-full", f.color)}
        style={{
          left: f.x, top: f.y, height: f.h, "--tilt": f.tilt,
          transformOrigin: "50% 100%", animationDelay: `${i * 0.35}s`,
        }}
      />
    ))}
  </div>
);
